import { zergApi } from "@/service/zerg";

const prefix = "setting/payroll/contribution";

class ContributionService {
    // Listar registros
    async index(params = {}) {
        try {
            const { data } = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    // Crear registro
    // async store(payload) {
    //     try {
    //         const { data } = await zergApi.post(`${prefix}/store`, payload);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // Mostrar un registro (se envía el id en el body)
    // async show(id) {
    //     try {
    //         const { data } = await zergApi.post(`${prefix}/show`, { id });
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // Actualizar un registro
    async update(payload) {
        try {
            const { data } = await zergApi.post(`${prefix}/update`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    // Eliminar un registro (id en el body)
    // async destroy(id) {
    //     try {
    //         const { data } = await zergApi.post(`${prefix}/destroy`, { id });
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }
}

export default new ContributionService();
